import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { IonicModule } from "@ionic/angular";

import { AddUserDepartmentPageRoutingModule } from "./add-user-department-routing.module";

import { AddUserDepartmentPage } from "./add-user-department.page";
import { TranslateModule } from "@ngx-translate/core";
import { HeaderModule } from "src/app/_component/header/header.module";
import { SelectDropdownModule } from "src/app/app/_component/select-dropdown/select-dropdown.module";
import { LoadingStiModule } from "src/app/_component/loading-sti/loading-sti.module";
import { ModalHeaderComponentModule } from "src/app/app/_component/modal-header/modal-header.module";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    AddUserDepartmentPageRoutingModule,
    TranslateModule,
    HeaderModule,
    SelectDropdownModule,
    LoadingStiModule,
    ModalHeaderComponentModule,
  ],
  declarations: [AddUserDepartmentPage],
})
export class AddUserDepartmentPageModule {}
